import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;
export const StyledTitle = styled.h2`
  display: flex;
  gap: 1.4rem;
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  margin-bottom: 0;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const StyledText = styled.div`
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
`;

export const StyledWarningToast = styled.div`
  display: flex;
  padding: 1.6rem;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  align-self: stretch;
  border: 1px solid ${({ theme }) => theme.colors.warning.light};
  background: ${({ theme }) => theme.colors.warning.lighter};
  border-radius: ${({ theme }) => theme.radius.small};

  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
`;

export const StyledErrorToast = styled.div`
  display: flex;
  padding: 1.6rem;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  align-self: stretch;
  border: 1px solid ${({ theme }) => theme.colors.error.main};
  background: ${({ theme }) => theme.colors.error.lighter};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
`;

export const StyledActionButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.6rem;
  padding-top: 1.8rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`;

export const StyledInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const StyledFontAwesomeErrorIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.error.main};
`;

export const StyledFontAwesomeWarningIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.warning.light};
`;
